/* global $,site_url,theme_url,alert */
function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}
$(function ()
{
  $.ajaxSetup ({
    cache: false
  });
  var inputTimer;

  /* !PRODUCT PAGE */
  /*-----------------------------------------------------------------------------------*/
  function priceLookup($form) {
    var priceids = [$("#category").val(),$('#size').val(),$('#colour').val(),$('#custom').val(),$('#custom2').val(),$('#custom3').val(),$('#custom4').val()],
      catID = $('#category').val(),
      size = $('#size').val(),
      colour = $('#colour').val(),
      custom = $('#custom').val(),
      custom2 = $('#custom2').val(),
      custom3 = $('#custom3').val(),
      custom4 = $('#custom4').val(),
      single = $('#singlePrice').val(),
      prodid = $("#prod_id").val(),
      quantity = $("input[name=quantity]").val(),
      error_txt = $form.find('.error_txt'),
      price_txt = $form.find('.price'),
      stock_txt = $form.find('.stock');
      
    //If no options have been set, but there is a single price row,
    //use a single figure instead of an array for priceids
    if(single > 0) { priceids = single; }
      
    error_txt.html('');
    if(stock_txt.hasClass("outofstock"))
    {
      stock_txt.animate({opacity:1},250);
    }
    else
    {
      stock_txt.animate({opacity:0},250);
    }
    price_txt.animate({opacity:0},250,function(){

      $.ajax({
        type: "POST",
        url: theme_url+"ajax/shop-get_price.php",
        data: { 	quantity: quantity,
            prc_id: priceids,
            prod_id: prodid,
            single: single,
            options: {
              catID : catID,
              size : size,
              col : colour,
              option : custom,
              option2 : custom2,
              option3 : custom3,
              option4 : custom4
            }
           },
        dataType: "json"
      })
      .done(function(data) {
        if(data.success===true)
        {
          if(parseInt(data.stock) > 0 || parseInt(data.use_stock) === 0)
          {
            price_txt.html(data.formatted_total);
            stock_txt.find('> p > span').html(data.stock);
          }
          price_txt.animate({opacity:1},250);
          stock_txt.animate({opacity:1},250);
          
          //Enable quantity and add button
          $("#cart-button .button-add").prop('disabled',false);
        }
        else
        {
          //Disable quantity and add button
          $("#cart-button .button-add").prop('disabled',true);

          if(data.errors.length > 0)
          {
            error_txt.html('<p>'+data.errors.join('<br>')+'</p>');
          }
        }
      });
    });
  }
  //!-Lookup price on page load
  //I've used #prod_id as the parameter because it is a child of .addtocart
  //and is always present
  priceLookup($("form.addtocart"));
  
  //!-Purchase options dropdowns
  $(".single-product-options select").change(function(){
    var form = $(this).closest("form.addtocart");
    priceLookup(form);
  });
  //!-Change of quantity
  $(document).on("keyup input change touchend","input#quantity",function() {
    var form = $(this).closest("form.addtocart");
    clearTimeout(inputTimer);
    inputTimer = setTimeout(function(){
      priceLookup(form);
    }, 250); //fires after .25 second
  });

  
  /* !CART */
  /*-----------------------------------------------------------------------------------*/	
  
  var item_id;
  
  /**
   * Updates the cart icon display
   * 
   * @param int num Current cart count
   * @param float val Currrent cart value
   * @return void
   */
  function update_cart_status(num,total) {
    var cart_status_count = $("#basket-info span.cart_count");
    var cart_status_holder = $("#basket-info");
    var cart_total = $("#basket-info .basketAmount span[itemprop=price]");
    if(num > 0)
    {
      cart_status_holder.addClass("active");
    }
    else
    {
      cart_status_holder.removeClass("active");
    }
    cart_status_count.text(num);
    if(total) {
      total = parseFloat(total).toFixed(2);
      cart_total.text(total);
    }
  }

  /**
   * Add to the cart using ajax
   *
   */
  function add_to_cart(post_data) {
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/shop-add_to_cart.php",
      data: post_data,
      dataType: "json"
    })
    .done(function(data) {
      if(data.success)
      {
        update_cart_status(data.count,data.grand_total);
        reload_cart();
                
        $("#cart-confirm > .alert").hide(); 
        $('form.addtocart .feedback').hide();
        $("#cart-confirm").fadeIn(250);
            $("#cart-confirm > .alert").fadeIn(500,function(){
                setTimeout(function(){ // Wait 10s before fading out
                  $('#cart-confirm > .alert').fadeOut(10000, function(){
                    $("#cart-confirm").fadeOut(250);
                  });
              }, 5000);
          });
      }
      else
      {
        if(data.errors.length > 0)
        {
          $('form.addtocart .feedback .errors').html('<p>'+data.errors.join('<br>')+'</p>');
          $('form.addtocart .feedback').show();
        }
      }
    });
  }
  
  $("form.addtocart").on("submit",function(e) {
    var post_data = $("form.addtocart").serializeArray(); 
    post_data.push({ name: "ajax", value: true });
    add_to_cart(post_data);
    e.preventDefault();
  });

  //Close the 'added to cart' confirmation box
  $("#cart-confirm > .alert").on("click",function(){
      $('#cart-confirm > .alert').fadeOut(500, function(){
          $("#cart-confirm").hide();
        });
  });
    
  /**
   * Recalculates and updates all cart totals
   */
  function rebuild_cart() {
    var subtotal_val = 		$(".subtotal_val"),
      shipping_label = 	$(".shipping_label"),
      shipping_val = 		$(".shipping_val"),
      discount_row = 		$(".discount_row"),
      discount_label = 	$(".discount_label"),
      discount_val = 		$(".discount_val"),
      discount_field = 	$(".voucher_code"),
      grand_total_val = 	$(".grand_total_val"),
      vat_val = 	$(".vat_val"),
      mobile_grand_total = $(".mobile_grand_total span[itemprop=price]");
    
    $.ajax({
      url: theme_url+"ajax/cart-get_values.php",
      dataType: "json"
    })
    .done(function(data) {
      update_cart_status(data.cart_count,data.grand_total);
      if(data.cart_count < 1)
      {
        //window.location.replace(data.cart_url);
      }
      else
      {
        //Update totals for each row
        var item_val;
        $.each(data.items, function(i,item) {
          item_val = parseFloat(item.data.price * item.quantity * item.carton_qty).toFixed(2);
          $(".item_"+item.data.id+" .item_total span[itemprop=price]").text(item_val);
          // Update mobile dropdown
          $("#item_row_"+item.data.id+" .price span[itemprop=price]").text(item_val);
          
          // Update total units
          $(".item_"+item.data.id+" .item_units").text(item.quantity * item.carton_qty);

        });
        
        // Show / hide minimum order notice
        if(data.subtotal < 500) {
          $('.alert-min-order').addClass('show');
        }
        else {
          $('.alert-min-order').removeClass('show');
        }

        //Set shipping
        if(parseInt(data.collect) === 1)
        {
          $(".shipping_options").slideUp("slow");
          shipping_label.html('');
          shipping_val.html('');
          $(".shipping_row").addClass("hidden");
          $(".notice-holder").html('');
        }
        else
        {
          if(parseInt(data.shipping_option.id) > 0)
          {
            $(".shipping_options").slideDown("slow");
            shipping_label.html(data.shipping_option.name);
            shipping_val.html('£'+parseFloat(data.shipping_cost).toFixed(2));
            $(".shipping_row").removeClass("hidden");
            $('.checkout_btn').removeClass("hidden");
            $('.checkout-proceed-button').removeClass("hidden");

            // Large delivery notice for UK orders
            if(parseInt(data.shipping_country.id) === 232 || parseInt(data.shipping_country.id) === 0) {
              if(data.shipping_weight > 60) {
                $(".notice-holder").html('<div class="alert alert-info">This order will be delivered on 1 or more pallets.  Please make sure your delivery address can accommodate a large delivery vehicle</div>');
              }
              else {
                $(".notice-holder").html('');
              }
            }
          }
          else {
            shipping_label.html('');
            shipping_val.html('');
            $(".shipping_row").addClass("hidden");
            $(".notice-holder").html('');
            // $('.checkout_btn').addClass("hidden");
            // $('.checkout-proceed-button').addClass("hidden");
          }
        }
        
        subtotal_val.html('£'+parseFloat(data.subtotal).toFixed(2));

        if(data.discount.amount > 0)
        {
          discount_row.removeClass('hidden');
          discount_label.html(data.discount.label);
          discount_val.html('- £'+parseFloat(data.discount.amount).toFixed(2));
          discount_field.val(data.discount.code);
          $(".apply_voucher_code").removeClass("add").addClass("remove");
          $(".apply_voucher_code .action").html("Remove");
        }
        else
        {
          discount_row.addClass('hidden');
          discount_label.html('');
          discount_val.html('');
          discount_field.val('');
          $(".apply_voucher_code").removeClass("remove").addClass("add");
          $(".apply_voucher_code .action").html("Apply");
        }
        vat_val.html('£'+parseFloat(data.vat).toFixed(2));
        grand_total_val.html('£'+parseFloat(data.grand_total).toFixed(2));
        mobile_grand_total.html(parseFloat(data.grand_total).toFixed(2));
      }
    });
  }

  /**
   * Fetches the cart data and reloads the entire cart (mobile only)
   */
  function reload_cart() {
    var mobileview = window.matchMedia('screen and (max-width:599px)');

    if (mobileview.matches) {
      $("#mobileBasket > .inner").load(site_url+"modules/shop-cart.php");
    }
  }
  
  //!-Remove item
  
  /**
   * Removes an item from the cart via ajax, hides the table row and updates the totals.
   * 
   * @uses rebuild_cart
   * @access public
   * @param object target jQuery object of the "remove" link.
   * @return void
   */
  function remove_cart_item(target) {
    var cart_id = target.data('id'),
      cart_row = target.closest("tr");
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/cart-remove.php",
      data: { cart_id: cart_id },
      dataType: "json"
    })
    .done(function(data) {
      if(data.success)
      {
        //count the columns
        var cols = cart_row.children("td").length;
        //Add divs inside the cells, animate, then remove
        cart_row.children("td").each(function() {
          $(this).wrapInner("<div></div>").children("div").slideUp(1000,function() {
              $(this).parent().remove(); 
            });
        });
        //Add a new cell with a remove message
        setTimeout(function(){
          if(data.count < 1)
          {
            window.location.replace(data.cart_url);
          }
          else
          {
            cart_row.append('<td class="removed" colspan="'+cols+'"><div style="display:none">Removed <a href="'+data.product_url+'">'+data.product_name+'</a></div></td>');
            cart_row.find('td > div').slideDown(500);
            rebuild_cart();
          }
        }, 1000);
      }
      else
      {
        if(data.error !=='')
        {
          alert(data.error);
        }
      }
    });
  }
  // $(document).on("click", ".basket .remove_item",function(e){
  $(document).on("click", ".remove_item",function(e){
    e.preventDefault();
    var clicked = $(this);
    remove_cart_item(clicked);
  });

  //!-Update cart quantity

  function update_cart_qty(item_id,qty) {
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/cart-update_qty.php",
      data: {
        item_id: item_id,
        qty: qty
      },
      dataType: "json"
    })
    .done(function(data) {
      $(".item_"+item_id+" .quantity p.error").fadeOut(250,function() { $(this).remove(); });
      $(".item_"+item_id+" .quantity input").val(data.qty);
      if(data.success)
      {
        rebuild_cart();
      }
      else
      {
        if(data.error !=='')
        {
          $('<p class="error" style="display:none">'+data.errors.join('<br>')+'</p>').appendTo(".item_"+item_id+" .quantity").fadeIn(250);
          //Fade after 4 seconds
          setTimeout(function() {
                  $(".item_"+item_id+" .quantity p.error").fadeOut(1000, function(){
                    $(this).remove();
                  });
              }, 4000);
        }
      }
    });
  }
  
  //On updating the quantity field
  var qty;
  $(document).on("keyup input change touchend",".basket .cart_qty",function() {
    item_id = $(this).closest("tr").data("item"),
      qty = $(this).val();
    clearTimeout(inputTimer);
    inputTimer = setTimeout(function(){
      update_cart_qty(item_id,qty);
    }, 250); //fires after .25 second
  });

  // Update quantity in mobile basket dropdown
  $(document).on("change", ".quantity-input", function(){
    item_id = $(this).data("id");
    qty = $(this).val();
    clearTimeout(inputTimer);
    inputTimer = setTimeout(function(){
      update_cart_qty(item_id,qty);
    }, 250); //fires after .25 second
  });

  //!-Edit custom info
  $(document).on("click",".edit_custominfo",function(e){
    $.fancybox.open({
      type: 'inline',
      src: $(this).attr("href")
    });
    e.preventDefault();
  });
  $(document).on("submit", ".form_custominfo",function(e){
    var ci_postdata = $(this).serializeArray(); 

    $.ajax({
      type: "POST",
      url: theme_url+"ajax/cart-update_custominfo.php",
      data: ci_postdata,
      dataType: "json"
    })
    .done(function(data) {
      if(data.success)
      {
        var html_val = nl2br(data.val);
        $(".basket .item_"+data.id+" .custominfo strong").html("&quot;"+html_val+"&quot;");
        $.fancybox.close();
      }
    });
  
    e.preventDefault();
  });
  
  /**
   * Set the delivery method or collection.
   * 
   * @access public
   * @param int collect 1 or 0 (overrides country and option, setting them both to 0)
   * @param int country The country ID
   * @param int option The shipping option ID
   * @return void
   */
  function set_shipping(collect, country, option) {
    collect = parseInt(collect);
    option = parseInt(option);
    country = parseInt(country);
    
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/cart-set_shipping.php",
      data: {
        collect: collect,
        option: option,
        country: country
      },
      dataType: "json"
    })
    .done(function(data) {
      if(data.success)
      {
        //Check the values returned are the same as those sent
        if(parseInt(data.collect) === collect && parseInt(data.country) === country && parseInt(data.option) === option)
        {
          rebuild_cart();
        }
      }
    });
  }
  
  //!-Choose delivery or collection
  $(".shipping_choice input[name=cart_collect]").on("click",function(){
    var cart_collect = $(this).val();
    if(parseInt(cart_collect) === 1)
    {
      //Collection
      set_shipping(1, 0, 0);
      $("#shipping_address").slideUp("slow");
    }
    else
    {
      //Delivery
      //Open the shipping options and select the first radio button
      $("#shipping_address").slideDown("slow");
      $(".shipping_options").slideDown("slow");
      $(".shipping_options label:first input:radio").click();
    }
  });

  //!-Update the shipping options when the country is changed
  // This sets the shipping choice to delivery, reveals the shipping options and selects the first one
  $(document).on("change",".ship_add_country",function(){
    
    var shipping_country = $(this).val();
    //Update all occurrences of the shipping country select
    $("select.ship_add_country").val(shipping_country);
    var opt_html = '';
    $("#cart_collect_0").prop('checked',true);

    // Create the required markup if it doesn't exist
    var shipping_options = $('.shipping_options');
    var radio_set = shipping_options.find('.radio-set');
    if(radio_set.length < 1) {
      radio_set = shipping_options.append('<div class="radio-set"/>');
    }

    //Hide the shipping options
    shipping_options.slideUp("slow").promise().done(function() {
      //Clear existing options
      radio_set.find("*").remove();
      //Look up new options via ajax
      $.ajax({
        type: "POST",
        url: theme_url+"ajax/cart-get_shipping_options.php",
        data: {
          country: shipping_country
        },
        dataType: "json"
      })
      .done(function(data) {
        //Output new options
        
        if($.isArray(data)) {
          $.each(data, function(i,opt){
            var num = i+1;
            opt_html = '<div class="custom-control custom-radio">' +
                      '<input type="radio" id="shipping_option_'+num+'" class="custom-control-input" name="shipping_option" value="' + opt.id + '" checked="checked">' +
                      '<label class="custom-control-label" for="shipping_option_'+num+'">' +
                      '<strong>'+ opt.name +'</strong> - <span itemprop="priceCurrency" content="GBP">£</span><span itemprop="price">'+ parseFloat(opt.cost).toFixed(2)+'</span>' +
                      '</label>' +
                      '</div>';
            radio_set.append(opt_html)
          });
          
          //Select the first one
          //Trigger a click to fire set_shipping()
          radio_set.find(".custom-radio:first input[name=shipping_option]").click(); 
          
          //Check first option on all occurrences to show it has been selected
          $(".shipping_options").each(function() {
            $(this).find(".radio-set .custom-radio:first input[name=shipping_option]").prop("checked",true);
          }); 
        }
        else {
          radio_set.append(data);
          set_shipping(0,shipping_country,0);
        }
        
        //Show the shipping options
        $(".shipping_options").slideDown("slow");
        
      });
    });
  });
  
  //!-Select a shipping option
  $(document).on("click",".shipping_options input[name=shipping_option]",function(){
    set_shipping(0, $(".ship_add_country:first").val(), $(this).val());
  });
  
  //!-Process voucher codes
  $(document).on("click",".apply_voucher_code",function(e){
    e.preventDefault();
    var btn = $(this),
      action,
      code_field = btn.closest(".voucher_code").find(".voucher_code_field"),
      code = code_field.val(),
      voucher_feedback = btn.closest(".voucher_code").find(".voucher_feedback");
    
    //Close the feedback message
    voucher_feedback.slideUp("250", function() { $(this).html(''); });
    
    if($(this).hasClass("add")) {
      //Apply code
      action = "add";
    }
    else if($(this).hasClass("remove")) {
      //Remove code
      action = "remove";
      code_field.val('');
    }
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/cart-set_promocode.php",
      data: {
        code: code,
        action: action
      },
      dataType: "json"
    })
    .done(function(data) {
      if(data.success) {
        if(data.label !=='') {
          voucher_feedback.html('<p class="win">'+data.label+'</p>').slideDown("500");
        }
        rebuild_cart();
      }
      else {
        if(data.error !=='') {
          voucher_feedback.html('<p class="lose">'+data.error+'</p>').slideDown("500");
        }
      }
    });		
  });

  /* !CHECKOUT */
  /*-----------------------------------------------------------------------------------*/

  // Disable the place order button when clicked
  $("#checkout_form.checkout-step-3").on('submit',function(){
    $("#checkout-submit-payment").addClass("running").attr('disabled',true);
  });

  /* !-Float labels */

  var field,
    field_block;
  
  $(document).on("focus", ".field .field_input", function() {
    field = $(this);
    field_block = field.closest(".field");
    if(!field.prop('disabled'))
    {
      field_block.addClass("focus");
    }
  });
  $(document).on("blur", ".field .field_input", function() {
    field = $(this);
    field_block = field.closest(".field");
    if(field.val().length === 0) {
      field_block.removeClass("focus");
    }
  });

  //!-Select the correct radio when a password is entered
  $("#acc_password").on("keypress",function(){
    $("#has_account_y").prop('checked',true);
  });
  
  //!-Address lookup
  $("#lookup_submit").on("click",function(e){
    e.preventDefault();
    var find_btn = $(this),
      number = $("#lookup_house").val(),
      postcode_field = $("#lookup_postcode"),
      postcode = postcode_field.val(),
      lookup_fields = $(this).closest("fieldset").find(".lookup"),
      manual_fields = $(this).closest("fieldset").find(".manual_entry");
      manual_fields.find(".is-invalid").removeClass("is-invalid").val('');
    if(postcode !== '')
    {
      postcode_field.removeClass('is-invalid');
      find_btn.addClass('running').prop('disabled',true);
      
      $.ajax({
        type: "POST",
        url: theme_url+"ajax/shop-address_lookup.php",
        data: { postcode: postcode },
        dataType: "json"
      })
      .done(function(data) {
        if(data.success)
        {
          find_btn.removeClass('running').prop('disabled',false);
          var line1_val = number;
          if(typeof data.route !== 'undefined') {
            line1_val += ' ' + data.route;
          }
          manual_fields.find("input[name$=add_line1]").val(line1_val).closest(".field").addClass("focus");
          if(typeof data.postal_town !== 'undefined') {
            manual_fields.find("input[name$=add_city]").val(data.postal_town).closest(".field").addClass("focus");
          }
          else if(typeof data.locality !== 'undefined') {
            manual_fields.find("input[name$=add_city]").val(data.locality).closest(".field").addClass("focus");
          }
          if(typeof data.postal_code !== 'undefined') {
            manual_fields.find("input[name$=add_postcode]").val(data.postal_code).closest(".field").addClass("focus");
          }
          if(typeof data.administrative_area_level_2 !== 'undefined') {
            manual_fields.find("input[name$=add_region]").val(data.administrative_area_level_2).closest(".field").addClass("focus");
          }
          else if(typeof data.administrative_area_level_1 !== 'undefined') {
            manual_fields.find("input[name$=add_region]").val(data.administrative_area_level_1).closest(".field").addClass("focus");
          }
          if(typeof data.country !== 'undefined') {
            $.ajax({
              type: "POST",
              url: theme_url+"ajax/checkout-country_lookup.php",
              data: { name: data.country },
              dataType: "json"
            })
            .done(function(country_data) {	
              manual_fields.find("select[name$=add_country]").val(country_data.id).change();
            });				
          }

          manual_fields.slideDown("slow");
          lookup_fields.slideUp("slow");
        }
      });			
    }
    else {
      postcode_field.addClass("is-invalid");
    }
  });
  //!--Open the manual entry fields and hide the lookup fields
  $(".lookup .skip_lookup").on("click",function(e){
    e.preventDefault();
    var lookup_fields = $(this).closest("fieldset").find(".lookup"),
      manual_fields = $(this).closest("fieldset").find(".manual_entry");
    
    manual_fields.find("input,select").removeClass("is-invalid").val('').closest(".field").removeClass("focus");
    manual_fields.slideDown("slow");
    lookup_fields.slideUp("slow");
  });
  //!--Clears and closes the manual entry fields, and hides the saved addresses list
  $(".manual_entry .goto_lookup").on("click",function(e) {
    e.preventDefault();
    var lookup_fields = $(this).closest("fieldset").find(".lookup"),
      manual_fields = $(this).closest("fieldset").find(".manual_entry"),
      address_list = $("#address-options"),
      address_btn = $("#show-addresses");

    lookup_fields.slideDown("slow");
    address_list.slideUp("slow");
    address_btn.removeClass("active");
    manual_fields.slideUp("slow",function(){
      manual_fields.find("input,select").removeClass("is-invalid").val('').closest(".field").removeClass("focus");
    });
    //Remove the active class from the saved address list
    $("#address-options .options-list a").removeClass("active");	
  });
  //!--Autocomplete delivery name fields from user name fields
  $("#user_first_names").on("blur", function() {
    if(!$("#ship_first_names").val())
    {
      $("#ship_first_names").val($("#user_first_names").val()).closest(".field").addClass("focus");
    }
  });
  $("#user_last_name").on("blur", function() {
    if(!$("#ship_last_name").val())
    {
      $("#ship_last_name").val($("#user_last_name").val()).closest(".field").addClass("focus");
    }
  });
  $("#user_email").on("blur", function() {
    if(!$("#ship_email").val())
    {
      $("#ship_email").val($("#user_email").val()).closest(".field").addClass("focus");
    }
  });
  $("#user_phone").on("blur", function() {
    if(!$("#ship_phone").val())
    {
      $("#ship_phone").val($("#user_phone").val()).closest(".field").addClass("focus");
    }
  });
  
  //!--Show saved addresses
  $("#show-addresses").on("click",function(e) {
    e.preventDefault();
    var address_list = $("#address-options"),
      address_btn = $(this);
    address_btn.addClass("active");
    address_list.slideDown("slow");
  });
  //!--Select a saved address
  $("#address-options .options-list a").on("click",function(e){
    e.preventDefault();
    var selected = $(this),
      add_id = $(this).data("add_id"),
      manual_fields = $(this).closest("fieldset").find(".manual_entry"),
      lookup_fields = $(this).closest("fieldset").find(".lookup");
    $.ajax({
      type: "POST",
      url: theme_url+"ajax/checkout-get_address.php",
      data: { id: add_id },
      dataType: "json"
    })
    .done(function(data) {
      if(data.success) {
        // Open the manual entry fields and hide the lookup fields        
        manual_fields.find("input,select").removeClass("is-invalid").val('').closest(".field").removeClass("focus");
        manual_fields.slideDown("slow");
        lookup_fields.slideUp("slow");
      
        // Populate the field values
        manual_fields.find("input,select").removeClass("is-invalid").val('');
        manual_fields.find("input[name$=first_names]").val(data.first_names).closest(".field").addClass("focus");
        manual_fields.find("input[name$=last_name]").val(data.last_name).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_id]").val(data.id).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_line1]").val(data.line1).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_line2]").val(data.line2).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_line3]").val(data.line3).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_town]").val(data.town).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_city]").val(data.city).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_region]").val(data.region).closest(".field").addClass("focus");
        manual_fields.find("input[name$=add_postcode]").val(data.postcode).closest(".field").addClass("focus");
        manual_fields.find("[name$=add_country]").val(data.country_id).closest(".field").addClass("focus");
        manual_fields.find("input[name$=email]").val(data.email).closest(".field").addClass("focus");
        manual_fields.find("input[name$=phone]").val(data.phone).closest(".field").addClass("focus");
        selected.siblings().removeClass("active");
        selected.addClass("active");
      }
    });
  });
  
  //!--Gift message actions
  //Check "is gift" and focus message box when "include message" is checked
  $("#include_gift_message").on("click",function(){
    if($(this).prop('checked')===true)
    {
      $("#is_gift").prop('checked',true);
      $("#gift_message").focus();
    }
  });
  //Uncheck "include message" when "is gift" is unchecked
  $("#is_gift").on("click",function(){
    if($(this).prop('checked')===false)
    {
      $("#include_gift_message").prop('checked',false);
    }
  });
  //Check "is gift" and "include message" when the user starts typing in the message box
  $("#gift_message").on("keypress",function(){
    $("#is_gift").prop('checked',true);
    $("#include_gift_message").prop('checked',true);
  });
  
  //Reveal editable fields in summary view
  $(".summary .edit").on("click",function(e) {
    var summary_container = $(this).closest(".summary"),
      editable_container = summary_container.parent().find(".editable");
    summary_container.slideUp("slow");
    editable_container.slideDown("slow");
    e.preventDefault();
  });
  
  //!Referral sources
  $(document).on("change","select#source",function(){
    var src_question = $(this).find(':selected').data('question'),
      src_text = $(this).find(':selected').text(),
      src_id = $(this).val();
    //Update hidden source_text field
    if(src_id > 0) {
      $("#source_text").val(src_text);
    } else {
      $("#source_text").val('');
    }
    //Show/hide details field
    if(src_question !=='') {
      $("#source_details_container label").text(src_question);
      $("#source_details_container").slideDown(500);
    } else {
      $("#source_details_container").slideUp(250,function(){
        $("#source_details_container label").text('');
      });
    }
  });
  
  //!-Register an account
  $(".account_prompt .register_user").on("click",function(e) {
    e.preventDefault();

    var reg_btn = $(this),
        account_prompt = $(this).closest(".account_prompt"),
        ap_title = account_prompt.find("h2"),
        ap_text = account_prompt.find("p"),
        ap_field = account_prompt.find("input[name=reg_pass]"),
        ap_btn = account_prompt.find(".register_user"),
        garnish_before = account_prompt.find(".garnish.before"),
        garnish_after = account_prompt.find(".garnish.after"),
        error_txt = account_prompt.find(".account_prompt_errors");
      
    // Add waiting status to button and disable it
    reg_btn.addClass('running').prop('disabled',true);

    //Get the checkout session data
    $.ajax({
      url: theme_url+"ajax/checkout-get_data.php",
      dataType: "json"
    })
    .done(function(data) {
      if(data !== "empty") {
        //register user
        $.ajax({
          type: "POST",
          url: theme_url+"ajax/register.php",
          data: { 
            reg_fname: data.user.first_names,
            reg_lname: data.user.last_name,
            reg_email: data.user.email,
            reg_pass: ap_field.val()
          },
          dataType: "json"
        })
        .done(function(reg_data) {	
          
          if(reg_data.errors.length > 0) {
            error_txt.html(reg_data.errors.join('<br>')).slideDown("slow");
          }
          else {
            //Clear the errors
            error_txt.fadeOut("slow",function() {
              $(this).html('');
            });
          }
          if(reg_data.success) {
            //Update visuals			
            ap_title.text("Welcome aboard!");
            ap_text.html("We've signed you up and logged you in.<br>You can now continue with your order and we'll remember your details next time.");	
            ap_field.hide();
            ap_btn.hide();
            garnish_before.removeClass("active");
            garnish_after.addClass("active");
          }
        });
      }
      setTimeout(function() {
        reg_btn.removeClass('running').prop('disabled',false);
      },1000);
    });
  });
  
  //!-Payment
  $("#payment_options .payment-option input").on("click",function() {
    var paymentForm = $(this).closest('.payment-option').find('.payment-form');
    $("#payment_options .payment-form").not(paymentForm).slideUp();
    if(paymentForm.length) {
      paymentForm.slideDown("slow");
    }
  });
  
});
